import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import Modal from '@mui/material/Modal'
import { Box, Typography } from '@mui/material'
import { CustomButton } from 'components/CustomButton'
import { IconInfor } from '../../../../assets/icons_svg'

function Modal_({
    themeColor,
    closeByClick,
    handleClose,
    onConfirm,
    open,
    title,
    text,
    type,
    t,
}) {
    return (
        <Modal
            open={open}
            onClose={closeByClick}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            disableEnforceFocus
            sx={{ backdropFilter: 'blur(2px)' }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '90%',
                    maxWidth: 470,
                    bgcolor: '#FFFFFF',
                    p: '30px 25px',
                    borderRadius: '12px',
                    boxShadow: '0px 8px 24px rgba(0,0,0,0.12)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '20px',
                }}
            >
                {type === 'stateRegister' && (
                    <Box display="flex" justifyContent="flex-end" width="100%">
                        <Box
                            component="i"
                            onClick={handleClose}
                            className="icon-ico_cancelar"
                            sx={{ fontSize: '20px', color: '#e01e36', cursor: 'pointer' }}
                        />
                    </Box>
                )}

                <IconInfor
                    sx={{
                        fontSize: '72px !important',
                        color: themeColor?.visual?.icons?.color || '#eea236',
                    }}
                />

                {type === 'stateRegister' && (
                    <Typography color="#5D5D5D" fontSize="14px" fontWeight={500} textAlign="center" lineHeight={1.6}>
                        {t(text)}
                    </Typography>
                )}

                {type === 'tokenRegister' && (
                    <Box display="flex" flexDirection="column" alignItems="center" gap="12px" width="100%">
                        <Typography color="#5D5D5D" fontSize="15px" fontWeight={700} textAlign="center">
                            {t(title)}
                        </Typography>
                        <Typography color="#5D5D5D" fontSize="14px" textAlign="center" lineHeight={1.6}>
                            {t(text)}
                        </Typography>
                        <CustomButton
                            size="sm"
                            variant="contained"
                            defaultColor="#5CB860"
                            onClick={onConfirm}
                            style={{ minWidth: '140px' }}
                        >
                            {t('Resend email')}
                        </CustomButton>
                    </Box>
                )}
            </Box>
        </Modal>
    )
}

Modal_.propTypes = {
    closeByClick: PropTypes.func,
    handleClose: PropTypes.func,
    onConfirm: PropTypes.func,
    open: PropTypes.bool,
    text: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
}

Modal_.defaultProps = {
    closeByClick: null,
    handleClose: null,
    open: false,
    text: '',
    title: '',
}

export default withTranslation()(Modal_)
